import React from 'react'

const logoLight = new URL('@/assets/Logo insaite blanco.png', import.meta.url).href
const logoDark = new URL('@/assets/Logo insaite red. azul orsuro.png', import.meta.url).href
const logoFullDark = new URL('@/assets/logo-full-dark.png', import.meta.url).href

type Size = 'small' | 'medium' | 'large'
type Variant = 'light' | 'dark' | 'violet'

interface LogoInsaiteProps {
  size?: Size
  position?: 'fixed' | 'relative'
  variant?: Variant
  aiOnly?: boolean // Muestra solo el símbolo de la marca (PNG original)
}

/** Logo oficial INSAITE (assets PNG) con variantes light, dark y violet. */
export function LogoInsaite({
  size = 'medium',
  position = 'relative',
  variant = 'light',
  aiOnly = false,
}: LogoInsaiteProps) {
  const className = `logo-insaite-container logo-${size} logo-${position}`
  const style =
    position === 'fixed' ? { position: 'fixed' as const, top: '4rem', right: '2rem' } : undefined

  // LOGO COMPLETO (Imagen con Brackets)
  if (!aiOnly) {
    const height = size === 'small' ? '40px' : size === 'medium' ? '56px' : '72px'
    const logoSrc = variant === 'dark' ? logoFullDark : logoLight

    let filter = 'none'
    if (variant === 'light') {
      filter = 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.3))'
    } else if (variant === 'violet') {
      // Filtro para violeta profundo empresarial (#5b21b6)
      filter =
        'invert(12%) sepia(91%) saturate(4155%) hue-rotate(261deg) brightness(92%) contrast(113%)'
    }

    return React.createElement(
      'div',
      { className: `${className} logo-full-brackets-img`, style },
      React.createElement('img', {
        src: logoSrc,
        alt: 'Insaite Full Logo',
        loading: 'eager',
        // @ts-ignore - fetchPriority is a valid attribute in modern browsers
        fetchPriority: 'high',
        decoding: 'async',
        width: '150',
        height: '58',
        style: {
          height,
          width: 'auto',
          display: 'block',
          objectFit: 'contain',
          filter,
        },
      }),
    )
  }

  // LOGO CONTRAÍDO
  let iconFilter = 'none'
  if (variant === 'light') {
    iconFilter = 'brightness(0) invert(1) drop-shadow(0 0 12px rgba(255, 255, 255, 0.6))'
  } else if (variant === 'violet') {
    iconFilter =
      'invert(12%) sepia(91%) saturate(4155%) hue-rotate(261deg) brightness(92%) contrast(113%)'
  }

  return React.createElement(
    'div',
    {
      className: `${className} ai-only`,
      style,
    },
    React.createElement('img', {
      src: logoDark,
      alt: 'Insaite Favicon',
      className: 'logo-insaite',
      loading: 'eager',
      // @ts-ignore
      fetchPriority: 'high',
      decoding: 'async',
      width: '40',
      height: '40',
      style: {
        height: size === 'small' ? '30px' : '40px',
        width: 'auto',
        objectFit: 'contain',
        filter: iconFilter,
      },
    }),
  )
}
